import { render } from "./ConfirmRedeemModal.vue?vue&type=template&id=52e6e6c6&scoped=true"
import script from "./ConfirmRedeemModal.vue?vue&type=script&lang=js"
export * from "./ConfirmRedeemModal.vue?vue&type=script&lang=js"

import "./ConfirmRedeemModal.vue?vue&type=style&index=0&id=52e6e6c6&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e6e6c6"]])

export default __exports__